module.exports = __webpack_public_path__ + "img/logo-mobile.d3c1d412.png";